import { BatchRecord } from '../types/batchRecord';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3003/api';

export const batchRecordApiService = {
  /**
   * Fetch all batch records from the backend
   */
  fetchBatchRecords: async (): Promise<BatchRecord[]> => {
    try {
      const response = await fetch(`${API_BASE_URL}/batch-records`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to fetch batch records');
      }

      return data.batchRecords;
    } catch (error) {
      console.error('Error fetching batch records from API:', error);
      throw error;
    }
  },

  /**
   * Fetch a single batch record by ID
   */
  fetchBatchRecordById: async (id: string): Promise<BatchRecord> => {
    try {
      const response = await fetch(`${API_BASE_URL}/batch-records/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to fetch batch record');
      }

      return data.batchRecord;
    } catch (error) {
      console.error('Error fetching batch record by ID from API:', error);
      throw error;
    }
  },

  /**
   * Create a new batch record
   */
  createBatchRecord: async (batchRecord: BatchRecord): Promise<BatchRecord> => {
    try {
      const response = await fetch(`${API_BASE_URL}/batch-records`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(batchRecord)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to create batch record');
      }

      return data.batchRecord;
    } catch (error) {
      console.error('Error creating batch record:', error);
      throw error;
    }
  },

  /**
   * Update an existing batch record
   */
  updateBatchRecord: async (batchRecord: BatchRecord): Promise<BatchRecord> => {
    try {
      const response = await fetch(`${API_BASE_URL}/batch-records/${batchRecord.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(batchRecord)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to update batch record');
      }

      return data.batchRecord;
    } catch (error) {
      console.error('Error updating batch record:', error);
      throw error;
    }
  },

  /**
   * Delete a batch record by ID
   */
  deleteBatchRecord: async (id: string): Promise<void> => {
    try {
      const response = await fetch(`${API_BASE_URL}/batch-records/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || 'Failed to delete batch record');
      }
    } catch (error) {
      console.error('Error deleting batch record:', error);
      throw error;
    }
  }
};
